import type { WarmTransferStatus } from './types';

export const WT_TOKENS = {
  green: '#0F5C45',
  greenDeep: '#0A4530',
  greenSoft: 'rgba(15, 92, 69, 0.10)',
  greenWash: 'rgba(15, 92, 69, 0.05)',
  brass: '#A8845C',
  brassDeep: '#8B6B47',
  brassSoft: 'rgba(168, 132, 92, 0.10)',
  brassTint: '#F0E9DC',
  negative: '#A8442E',
  negativeSoft: 'rgba(168, 68, 46, 0.10)',
  warning: '#B5803D',
  warningSoft: 'rgba(181, 128, 61, 0.12)',
  ink3: '#75706A',
  ink4: '#A8A39B',
  ink5: '#D9D5CC',
  iriLinear:
    'linear-gradient(120deg, #4D2855 0%, #8E3567 28%, #D8625F 55%, #D49545 80%, #0F5C45 100%)',
  iriDot: 'linear-gradient(135deg, #4D2855 0%, #D8625F 55%, #D49545 100%)',
  shadowXs: '0 1px 1px rgba(28,24,18,0.04)',
  shadowSm: '0 1px 2px rgba(28,24,18,0.05), 0 1px 3px rgba(28,24,18,0.04)',
  shadowMd: '0 1px 3px rgba(28,24,18,0.05), 0 4px 12px rgba(28,24,18,0.06), 0 8px 24px rgba(28,24,18,0.05)',
} as const;

export const WT_PRIORITY_LABELS: Record<
  WarmTransferStatus,
  { label: string; tone: 'negative' | 'warning' | 'neutral' | 'positive' }
> = {
  frustrated: { label: 'Urgent', tone: 'negative' },
  anxious: { label: 'Sensitive', tone: 'warning' },
  neutral: { label: 'Standard', tone: 'neutral' },
  positive: { label: 'Positive', tone: 'positive' },
};

export const WT_STATUS_PILL: Record<
  WarmTransferStatus,
  { bg: string; color: string; label: string }
> = {
  frustrated: { bg: WT_TOKENS.negativeSoft, color: WT_TOKENS.negative, label: 'Frustrated' },
  anxious: { bg: WT_TOKENS.warningSoft, color: WT_TOKENS.warning, label: 'Anxious' },
  neutral: { bg: 'var(--surface-mute)', color: 'var(--ink-1)', label: 'Neutral' },
  positive: { bg: WT_TOKENS.greenSoft, color: WT_TOKENS.green, label: 'Positive' },
};

export const WT_TONE_COLORS = {
  negative: { c: WT_TOKENS.negative, bg: WT_TOKENS.negativeSoft },
  warning: { c: WT_TOKENS.warning, bg: WT_TOKENS.warningSoft },
  neutral: { c: 'var(--ink-1)', bg: 'var(--surface-mute)' },
  positive: { c: WT_TOKENS.green, bg: WT_TOKENS.greenSoft },
} as const;
